import React from 'react';
import classnames from 'classnames';
import UserAvatar from '../User/Avatar/index';
import UserLink from '../User/Link/index';
import s from './ProfileIdentityMobile.scss';
export class ProfileIdentityMobile extends React.PureComponent {
    render() {
        const { className, user, tagline, statsComponent } = this.props;
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['root'], className)
        }, /*#__PURE__*/ React.createElement(UserAvatar, {
            size: 80,
            user: user,
            className: s['user-avatar']
        }), /*#__PURE__*/ React.createElement("div", {
            className: s['user-details']
        }, /*#__PURE__*/ React.createElement("h1", {
            className: s['user-link']
        }, /*#__PURE__*/ React.createElement(UserLink, {
            className: s['user-link-text'],
            symbolClassName: s['user-link-icon'],
            user: user
        })), tagline && /*#__PURE__*/ React.createElement("div", {
            className: s['user-label']
        }, tagline), statsComponent));
    }
}
export default ProfileIdentityMobile;
